import { useState } from "react";
import { ArrowLeft, ArrowRight, X } from "lucide-react";
import LetterCard from "@/components/LetterCard";
import { t } from "@/i18n";

/* Mêmes bornes que Quiz.jsx : hauteur exacte du header mobile (h-16) et
   de la barre d'onglets du bas, pour ne jamais passer derrière elles. */
const NAV_TOP = "4rem";
const NAV_BOTTOM = "calc(3.4rem + env(safe-area-inset-bottom))";

/* Écran d'apprentissage : une fiche par lettre de la sélection, que l'on
   fait défiler avant de commencer le quiz. Même composant utilisé par
   PracticeAlphabet ET le Daily Plan — pour ne jamais réinventer un écran
   différent selon l'endroit où on apprend l'alphabet. */
export default function AlphabetLearnScreen({
  letters,
  onAudio,
  onDone,
  onExit,
}) {
  const [i, setI] = useState(0);
  const l = letters[i];
  const last = i + 1 >= letters.length;

  return (
    <div
      className="fixed inset-x-0 z-20 bg-background flex flex-col md:static md:z-auto"
      style={{ top: NAV_TOP, bottom: NAV_BOTTOM }}
    >
      <div className="shrink-0 px-4 pt-3 pb-2 flex items-center justify-between gap-3">
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-primary">
            {t("alphabetlearnscreen.decouverte_progression", {
              current: i + 1,
              total: letters.length,
            })}
          </div>
          <p className="text-xs text-muted-foreground mt-0.5">
            {t("alphabetlearnscreen.regarde_ces_lettres_avant_de_t")}
          </p>
        </div>
        {onExit && (
          <button
            onClick={onExit}
            aria-label={t("alphabetlearnscreen.quitter")}
            className="shrink-0 w-8 h-8 rounded-full border grid place-items-center hover:bg-secondary transition"
          >
            <X size={15} />
          </button>
        )}
      </div>
      <div className="shrink-0 px-4">
        <div className="flex gap-1 mb-2">
          {letters.map((_, k) => (
            <div
              key={k}
              className={`h-1.5 flex-1 rounded-full ${k <= i ? "bg-primary" : "bg-secondary"}`}
            />
          ))}
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto px-4 flex items-center justify-center">
        <div className="w-full max-w-md rounded-3xl border bg-card p-4 sm:p-6">
          <LetterCard letter={l} onAudio={onAudio} />
        </div>
      </div>
      <div className="shrink-0 border-t bg-background/95 backdrop-blur-xl p-3">
        <div className="max-w-md mx-auto flex gap-2">
          {i > 0 && (
            <button
              onClick={() => setI(i - 1)}
              className="px-4 py-3 rounded-2xl border font-semibold"
            >
              <ArrowLeft size={16} />
            </button>
          )}
          <button
            onClick={() => (last ? onDone() : setI(i + 1))}
            className="flex-1 py-3 rounded-2xl bg-primary text-primary-foreground font-bold flex items-center justify-center gap-2"
          >
            {last
              ? t("alphabetlearnscreen.commencer_l_entrainement")
              : t("alphabetlearnscreen.suivant")}{" "}
            <ArrowRight size={17} />
          </button>
        </div>
      </div>
    </div>
  );
}
